/**
 * Hands a file the running app stores behind access control to the browser's downloader.
 *
 * A download node knows which URL to fetch but not how the app is allowed to fetch it: exchanging
 * the URL for a short-lived access token, and working around the platforms that refuse a
 * cross-host download, is the engine's business.
 */
export abstract class EngineFileDownloads {
  /** Downloads the file at `fileUrl`, obtaining access for it first. */
  abstract downloadSecureFile(fileUrl: string): void;
}
